<template>
    <div style="display: flex;">
        <el-input-number v-model="value1" :placeholder="placeholder"/>
        <div style="margin: 0 10px;">
            -
        </div>
        <el-input-number v-model="value2" :placeholder="placeholder"/>
    </div>
</template>

<script>

	export default {
		props: {
			modelValue:{
                type:String,
                default:''
            },
            placeholder:{
                type:String,
                default:'请输入'
            }
		},
		data() {
			return {
                value1:0,
                value2:0,
                value:''
			}
		},
		mounted() {
			if(this.modelValue!=""){
                this.value1 = Number(this.modelValue.split(',')[0]) || 0;
                this.value2 = Number(this.modelValue.split(',')[1]) || 0;
            }
		},
        watch:{
            modelValue(val){
				this.value1 = Number(val.split(',')[0]) || "";
                this.value2 = Number(val.split(',')[1]) || "";
			},
            value1(){
                this.value = [this.value1,this.value2].join(',');
                this.$emit('update:modelValue', this.value)
            },
            value2(){
                this.value = [this.value1,this.value2].join(',');
                this.$emit('update:modelValue', this.value)
            }
        },
		methods: {
           
		}
	}
</script>

<style scoped>

</style>
